export default "__VITE_ASSET__pjEF9osG__"